import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Job } from '../class/job.class';
import { JobModel } from '../models/job.model';
import { StatusEnum } from '../enums/status.enum';
import { TaskEnum } from '../enums/task.enum';
import { TaskModel } from '../models/task.model';
import { WsUpdateTaskMessage } from '../models/ws-update-task-message.model';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  constructor(
    private http: HttpClient
  ) { }

  getClientJobs(): Observable<Job[]> {
    const url: string = `${environment.apiUrl}/jobs`;
    return this.http.get<JobModel[]>(url).pipe(
      map((jobs: JobModel[]) => {
        return jobs.map((job: JobModel) => {
          return new Job(job)
        });
      }))
  }

  getClientJobById(id: string): Observable<Job> {
    const url: string = `${environment.apiUrl}/jobs/${id}`;
    return this.http.get<JobModel>(url).pipe(
      map((job: JobModel) => new Job(job))
    )
  }

  delete(id: number): Observable<any> {
    const url: string = `${environment.apiUrl}/jobs/${id}`;
    return this.http.delete(url)
  }

  /**
   * Met à jour la tâche d'un job à partir d'un message WebSocket
   * @param jobs Liste des jobs actuels
   * @param message Message reçu via WebSocket
   * @returns Nouvelle liste de jobs avec la tâche mise à jour
   */
  updateJobsFromWsMessage(jobs: Job[], message: WsUpdateTaskMessage): Job[] {
    return jobs.map(job => {
      if (job.id !== message.jobId) return job;

      const jobData = job.data;

      const updatedTasks: TaskModel[] = jobData.tasks.map(task => {
        if (task.id !== message.taskId) return task;

        return {
          ...task,
          status: StatusEnum[message.status as keyof typeof StatusEnum],
          type: TaskEnum[message.type as keyof typeof TaskEnum],
          message: message.message,
          progress: message.progress,
          updated_at: message.updated_at ? new Date(message.updated_at) : null,
          created_at: message.created_at ? new Date(message.created_at) : task.created_at
        };
      });

      const updatedJob = new Job({
        ...jobData,
        tasks: updatedTasks
      });

      return updatedJob;
    });
  }

  postSoundsParameters(jobId: number, taskId: number, originalVoiceVolume: number, translatedVoiceVolume: number, musicsAndSoundsVolume: number): Observable<any> {
    const url: string = `${environment.apiUrl}/jobs/${jobId}/${taskId}/sound-parameters`;
    return this.http.post(url, {
      "originalVoiceVolume": originalVoiceVolume,
      "musicAfxVolume": musicsAndSoundsVolume,
      "translatedVoiceVolume": translatedVoiceVolume,
    })
  }
}
